// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jEfH","field":"styles_field__1GcfZ","fieldCol":"styles_fieldCol__CH6Nd","diffCol":"styles_diffCol__2PljW","diff":"styles_diff__3Ntzf"};